const thirdRepair = () => import('@/pages/thirdRepair/index')
const thirdRepairFastPhoto = () => import('@/pages/thirdRepair/fastPhoto')
const thirdRepairSignRepair = () => import('@/pages/thirdRepair/thirdRepairSignRepair')
const thirdRepairDetailPop = () => import('@/pages/thirdRepair/thirdRepairDetailPop')
const thirdRepairRegisterOrder = () => import('@/pages/thirdRepair/thirdRepairRegisterOrder')
const thirdRepairAddkit = () => import('@/pages/thirdRepair/thirdRepairAddkit')
const thirdRepairAddWork = () => import('@/pages/thirdRepair/thirdRepairAddWork')
const createThirdRepair = () => import('@/pages/thirdRepair/createThirdRepair')
const thirdRepairDetailList = () => import('@/pages/thirdRepair/thirdRepairDetailList')
const thirdRepairDetailListChange = () => import('@/pages/thirdRepair/thirdRepairDetailListChange')
const thirdRepairSignOrder = () => import('@/pages/thirdRepair/thirdRepairSignOrder')
const thirdRepairLog = () => import('@/pages/thirdRepair/thirdRepairLog')

// const thirdRepairAudit = () => import('@/pages/thirdRepairAudit/index')  // 维保清单审核

// const thirdrepairClose = () => import('@/pages/thirdrepairClose/index')  // 维保结算审核

// const accidentAudit = () => import('@/pages/thirdaccident/audit')    // 维保清单审核

// 事故车审核
const accidentAudit = () => import('@/pages/thirdrepairAuditCenter/thirdaccident/audit/')
const accidentdetail = () => import('@/pages/thirdrepairAuditCenter/thirdaccident/detail')
const accidentorderaudit = () => import('@/pages/thirdrepairAuditCenter/thirdaccident/audit/orderaudit')
const accidentDetailPop = () => import('@/pages/thirdrepairAuditCenter/thirdaccident/accidentDetailPop')
const accidentClose = () => import('@/pages/thirdrepairAuditCenter/thirdaccident/close')
const accidentcloseAudit = () => import('@/pages/thirdrepairAuditCenter/thirdaccident/close/closeAudit')

// 事故订单新审核
const thirdNewAccidentOrder = () => import('@/pages/thirdrepairAuditCenter/thirdNewAccidentOrder/audit/')
const accidentOrderdetail = () => import('@/pages/thirdrepairAuditCenter/thirdNewAccidentOrder/audit/detail')
const accidentlistaduit = () => import('@/pages/thirdrepairAuditCenter/thirdNewAccidentOrder/audit/listaduit')
const accidentgoodsList = () => import('@/pages/thirdrepairAuditCenter/thirdNewAccidentOrder/audit/components/goodsInfo/components/goodsList/')

/* *修改后的审核* */
const thirdRepairAudit = () => import('@/pages/thirdrepairAuditCenter/audit')
const thirdRepairClose = () => import('@/pages/thirdrepairAuditCenter/close')

// 维保车审核
const aftermarketAudit = () => import('@/pages/thirdrepairAuditCenter/thirdaftermarket/audit/')
const aftermarketClose = () => import('@/pages/thirdrepairAuditCenter/thirdaftermarket/close/')
const aftermarketorderaudit = () => import('@/pages/thirdrepairAuditCenter/thirdaftermarket/audit/orderaudit')
const aftermarketcloseAudit = () => import('@/pages/thirdrepairAuditCenter/thirdaftermarket/close/orderaudit')
const lookCoupon = () => import('@/pages/lookCoupon')
const lookCouponDetail = () => import('@/pages/lookCoupon/detail')
const maintenanceRecord = () => import('@/pages/thirdrepairAuditCenter/thirdaftermarket/maintenanceRecord')

// 维保审核（新）
const newAudit = () => import('@/pages/thirdrepairAuditCenter/thirdaNew/audit/')
const neworderaudit = () => import('@/pages/thirdrepairAuditCenter/thirdaNew/audit/orderaudit')
const newdetaillist = () => import('@/pages/thirdrepairAuditCenter/thirdaNew/audit/detaillist')
const newlistaduit = () => import('@/pages/thirdrepairAuditCenter/thirdaNew/audit/listaduit')
const newpopdetail = () => import('@/pages/thirdrepairAuditCenter/thirdaNew/audit/popdetail')
// const lossDetail = () => import('@/pages/thirdrepairAuditCenter/thirdaNew/audit/lossDetail')
const newpopdetailAll = () => import('@/pages/thirdrepairAuditCenter/thirdaNew/audit/popdetailAll')
const repairGoodList = () => import('@/pages/thirdrepairAuditCenter/thirdaNew/audit/repairGoodList')

const newcoupon = () => import('@/pages/thirdrepairAuditCenter/thirdaNew/audit/coupon')
const largeAmountAuditLog = () => import('@/pages/thirdrepairAuditCenter/thirdaNew/audit/largeAmountAuditLog')

// 翻新工单
const renovationAudit = () => import('@/pages/thirdrepairAuditCenter/thirdarenovation/audit/')
const renovationorderaudit = () => import('@/pages/thirdrepairAuditCenter/thirdarenovation/audit/orderaudit')
const renovationdetail = () => import('@/pages/thirdrepairAuditCenter/thirdarenovation/detail')
const renovationClose = () => import('@/pages/thirdrepairAuditCenter/thirdarenovation/close/')
const renovationcloseAudit = () => import('@/pages/thirdrepairAuditCenter/thirdarenovation/close/orderaudit')

const rectificationAudit = () => import('@/pages/thirdrepairAuditCenter/thirdarectification/audit/')
const rectificationorderaudit = () => import('@/pages/thirdrepairAuditCenter/thirdarectification/audit/orderaudit')
const rectificationdetail = () => import('@/pages/thirdrepairAuditCenter/thirdarectification/detail')
const rectificationClose = () => import('@/pages/thirdrepairAuditCenter/thirdarectification/close/')
const rectificationcloseAudit = () => import('@/pages/thirdrepairAuditCenter/thirdarectification/close/orderaudit')

const maintainInfo = () => import('@/pages/thirdrepairAuditCenter/maintainInfo/')
const verificateCoupon = () => import('@/pages/verificateCoupon/index')
// 工时配件
const thirdDetailPop = () => import('@/pages/thirdrepairAuditCenter/components/thirdDetailPop')
export default [{
  path: '/thirdRepair',
  name: '/thirdRepair',
  component: thirdRepair,
  meta: {
    storeKey: 'trs.thirdRepair'
  }
},

{
  path: '/verificateCoupon',
  name: '/verificateCoupon',
  component: verificateCoupon,
  meta: {
    storeKey: 'trs.coupon'
  }
},
{
  path: '/thirdrepairMaintainInfo',
  name: '/thirdrepairMaintainInfo',
  component: maintainInfo,
  meta: {}
},
{
  path: '/thirdRepairSignRepair',
  name: '/thirdRepairSignRepair',
  component: thirdRepairSignRepair,
  meta: {}
},
{
  path: '/thirdRepairDetailPop',
  name: '/thirdRepairDetailPop',
  component: thirdRepairDetailPop,
  meta: {}
},
{
  path: '/thirdRepairRegisterOrder',
  name: '/thirdRepairRegisterOrder',
  component: thirdRepairRegisterOrder,
  meta: {}
},
{
  path: '/thirdRepairAddkit',
  name: '/thirdRepairAddkit',
  component: thirdRepairAddkit,
  meta: {}
},
{
  path: '/thirdRepairAddWork',
  name: '/thirdRepairAddWork',
  component: thirdRepairAddWork,
  meta: {}
},
{
  path: '/createThirdRepair',
  name: '/createThirdRepair',
  component: createThirdRepair,
  meta: {}
},
{
  path: '/thirdRepairDetailList',
  name: 'ThirdRepairDetailList',
  component: thirdRepairDetailList,
  meta: {
    cache: true
  }
},
{
  path: '/thirdRepairDetailListChange',
  name: 'ThirdRepairDetailListChange',
  component: thirdRepairDetailListChange,
  meta: {
    cache: true,
    storeKey: 'trs.thirdRepair'
  }
},
{
  path: '/thirdRepairSignOrder',
  name: '/thirdRepairSignOrder',
  component: thirdRepairSignOrder,
  meta: {}
},
{
  path: '/thirdRepairFastPhoto',
  name: '/thirdRepairFastPhoto',
  component: thirdRepairFastPhoto,
  meta: {}
},
// {
//   path: '/thirdRepairAudit',
//   name: 'thirdRepairAudit',
//   component: thirdRepairAudit,
//   meta: {
//     storeKey: 'trs.thirdRepairAudit'
//   }
// },
{
  path: '/orderaudit',
  name: '/orderaudit',
  component: aftermarketorderaudit,
  meta: {}
},
{
  path: '/aftermarketClose',
  name: 'aftermarketClose',
  component: aftermarketClose,
  meta: {
    storeKey: 'trs.settlementAudit'
  }
},
{
  path: '/aftermarketcloseAudit',
  name: 'aftermarketcloseAudit',
  component: aftermarketcloseAudit,
  meta: {}
},
{
  path: '/accidentdetail',
  name: 'accidentdetail',
  component: accidentdetail,
  meta: {

  }
},
{
  path: '/accidentorderaudit',
  name: 'accidentorderaudit',
  component: accidentorderaudit,
  meta: {}
},
{
  path: '/accidentDetailPop',
  name: 'accidentDetailPop',
  component: accidentDetailPop,
  meta: {}
},
{

  path: '/accidentClose',
  name: 'accidentClose',
  component: accidentClose,
  meta: {
    storeKey: 'trs.settlementAudit'
  }
},
{
  path: '/accidentcloseAudit',
  name: 'accidentcloseAudit',
  component: accidentcloseAudit,
  meta: {}
},
{
  path: '/thirdRepairAudit',
  name: 'thirdRepairAudit',
  component: thirdRepairAudit,
  meta: {
    storeKey: 'trs.repairListAudit'
  }
},
{
  path: '/thirdRepairClose',
  name: 'thirdRepairClose',
  component: thirdRepairClose,
  meta: {
    storeKey: 'trs.settlementAudit'
  }
},
{
  path: '/accidentAudit', // 事故清单审核
  name: 'accidentAudit',
  component: accidentAudit,
  meta: {
    storeKey: 'trs.repairListAudit'
  }
},
{
  path: '/aftermarketAudit', // 维保清单审核
  name: 'aftermarketAudit',
  component: aftermarketAudit,
  meta: {
    storeKey: 'trs.repairListAudit'
  }
},
{
  path: '/lookCoupon', // 维保清单审核
  name: 'lookCoupon',
  component: lookCoupon,
  meta: {
    storeKey: '*'
  }
},
{
  path: '/lookCouponDetail', // 维保清单审核
  name: 'lookCouponDetail',
  component: lookCouponDetail,
  meta: {
    storeKey: '*'
  }
},
{
  path: '/maintenanceRecord', // 近半年维修记录
  name: 'maintenanceRecord',
  component: maintenanceRecord,
  meta: {
    storeKey: '*'
  }
},
{
  path: '/newAudit', // 维保审核（新）
  name: 'NewAudit',
  component: newAudit,
  meta: {
    storeKey: 'trs.repairListAudit'
  }
},
{
  path: '/neworderaudit', // 维保审核（新）
  name: 'neworderaudit',
  component: neworderaudit,
  meta: {
    storeKey: '*'
  }
},
{
  path: '/newdetaillist', // 维保审核（新）
  name: 'newdetaillist',
  component: newdetaillist,
  meta: {
    storeKey: '*'
  }
},
{
  path: '/newlistaduit', // 维保审核（新）
  name: 'newlistaduit',
  component: newlistaduit,
  meta: {
    storeKey: '*'
  }
},
{
  path: '/newpopdetail', // 维保审核（新）
  name: 'newpopdetail',
  component: newpopdetail,
  meta: {
    storeKey: '*'
  }
},
// {
//   path: '/lossDetail', // 修改详情
//   name: 'lossDetail',
//   component: lossDetail,
//   meta: {
//     storeKey: '*'
//   }
// },
{
  path: '/newpopdetailAll', // 维保审核（新）
  name: 'newpopdetailAll',
  component: newpopdetailAll,
  meta: {
    storeKey: '*'
  }
},
{
  path: '/repairGoodList', // 维保审核（新）
  name: 'repairGoodList',
  component: repairGoodList,
  meta: {
    storeKey: '*'
  }
},

{
  path: '/newcoupon', // 维保审核（新）
  name: 'newcoupon',
  component: newcoupon,
  meta: {
    storeKey: '*'
  }
},
{
  path: '/largeAmountAuditLog',
  name: 'largeAmountAuditLog',
  component: largeAmountAuditLog,
  meta: {
    storeKey: '*'
  }
},

// 翻新工单
{
  path: '/renovationAudit', // 翻新清单审核
  name: 'renovationAudit',
  component: renovationAudit,
  meta: {
    storeKey: 'trs.repairListAudit'
  }
},
{
  path: '/renovationorderaudit', // 翻新清单审核
  name: 'renovationorderaudit',
  component: renovationorderaudit,
  meta: {}
},
{
  path: '/renovationdetail', // 翻新清单审核
  name: 'renovationdetail',
  component: renovationdetail,
  meta: {}
},
{
  path: '/renovationClose', // 翻新结算审核
  name: 'renovationClose',
  component: renovationClose,
  meta: {
    storeKey: 'trs.settlementAudit'
  }
},
{
  path: '/renovationcloseAudit',
  name: 'renovationcloseAudit',
  component: renovationcloseAudit,
  meta: {}
},
{
  path: '/thirdDetailPop',
  name: 'thirdDetailPop',
  component: thirdDetailPop,
  meta: {}
},
// 整改工单
{
  path: '/rectificationAudit',
  name: 'rectificationAudit',
  component: rectificationAudit,
  meta: {
    storeKey: 'trs.repairListAudit'
  }
},
{
  path: '/rectificationorderaudit',
  name: 'rectificationorderaudit',
  component: rectificationorderaudit,
  meta: {}
},
{
  path: '/rectificationdetail',
  name: 'rectificationdetail',
  component: rectificationdetail,
  meta: {}
},
{
  path: '/rectificationClose',
  name: 'rectificationClose',
  component: rectificationClose,
  meta: {
    storeKey: 'trs.settlementAudit'
  }
},
{
  path: '/rectificationcloseAudit',
  name: 'rectificationcloseAudit',
  component: rectificationcloseAudit,
  meta: {}
},
{
  path: '/thirdRepairLog',
  name: 'thirdRepairLog',
  component: thirdRepairLog,
  meta: {}
},
// 事故订单新审核
{
  path: '/thirdNewAccidentOrder',
  name: 'thirdNewAccidentOrder',
  component: thirdNewAccidentOrder,
  meta: {
    storeKey: '*'
  }
},
{
  path: '/accidentOrderdetail',
  name: 'accidentOrderdetail',
  component: accidentOrderdetail,
  meta: {}
},
{
  path: '/accidentlistaduit',
  name: 'accidentlistaduit',
  component: accidentlistaduit,
  meta: {}
},
{
  path: '/accidentgoodsList',
  name: 'accidentgoodsList',
  component: accidentgoodsList,
  meta: {}
},
{
  path: '/thirdRepair/unfinishedDetail',
  name: 'unfinishedDetail',
  component: () => import('@/pages/thirdRepair/unfinishedDetail.vue'),
  meta: {}
}
]



// WEBPACK FOOTER //
// ./src/router/thirdRepair/index.js